import { render, staticRenderFns } from "./Seccion_almacen.vue?vue&type=template&id=718f2511&lang=pug&"
import script from "./Seccion_almacen.vue?vue&type=script&lang=js&"
export * from "./Seccion_almacen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports